import styled from 'styled-components';

export const MainContainer = styled.div`
  padding: 26px 30px 60px;
  background: #F4F5F7;
  min-height: 100vh;
  margin-left: 15%;
  width: 85%;
  color: #1E2130;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    padding: 16px;
  }
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;

  h1 {
    font-size: 22px;
    margin: 0;
    font-weight: 800;
    color: #1E2130;
  }

  p {
    margin: 4px 0 0;
    color: #6B7280;
    font-size: 13.5px;
  }
`;

export const NavSection = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 20px;
  background: #fff;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid #E7E8EC;
  overflow-x: auto;
`;

export const SubNavButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  color: ${props => props.active ? '#fff' : '#5b4230'};
  font-weight: 700;
  background: ${props => props.active ? '#EA5B2A' : 'transparent'};
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${props => props.active ? '#CE4A1E' : '#FDEEE7'};
  }
`;

export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.cols || 4}, 1fr);
  gap: 14px;
  margin-bottom: 22px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const KpiCard = styled.div`
  background: ${props => props.accent ? '#EA5B2A' : '#181A20'};
  color: #fff;
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.04);

  .lbl {
    font-size: 11px;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: ${props => props.accent ? '#ffe3d6' : '#b7b9c4'};
    font-weight: 700;
  }

  .val {
    font-size: 26px;
    font-weight: 800;
    margin-top: 6px;
  }

  .sub {
    font-size: 11.5px;
    color: ${props => props.accent ? '#ffd9c6' : '#8d90a0'};
    margin-top: 4px;
  }
`;

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: ${props => props.ratio || '1.3fr 1fr'};
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const CardBox = styled.div`
  background: #FFFFFF;
  border: 1px solid #E7E8EC;
  border-radius: 14px;
  padding: 18px 20px;

  h3 {
    margin: 0 0 4px;
    font-size: 14.5px;
    font-weight: 800;
    color: #1E2130;
  }

  .hint {
    font-size: 12px;
    color: #6B7280;
    margin-bottom: 10px;
  }
`;

export const BalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1px solid #E7E8EC;
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }

  .bal-name {
    font-weight: 700;
    cursor: pointer;
    color: #1E2130;

    &:hover {
      color: #CE4A1E;
      text-decoration: underline;
    }
  }

  .bal-tag {
    font-size: 10.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
    margin-left: 6px;
  }

  .tag-advance {
    background: #EAF1FE;
    color: #2F6FED;
  }

  .tag-reimb {
    background: #F1EAFB;
    color: #8B5CE0;
  }

  .amt-pos {
    color: #1E9E5A;
    font-weight: 800;
  }

  .amt-owe {
    color: #B9791A;
    font-weight: 800;
  }
`;

export const FiltersBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  background: #fff;
  border: 1px solid #E7E8EC;
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 16px;

  .field {
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
      font-size: 11px;
      font-weight: 700;
      color: #6B7280;
      text-transform: uppercase;
      letter-spacing: .04em;
    }

    select, input {
      padding: 8px 10px;
      border: 1px solid #E7E8EC;
      border-radius: 8px;
      font-size: 13px;
      min-width: 140px;
      background: #fff;
      color: #1E2130;
      outline: none;
    }
  }

  .grow {
    flex: 1;
    min-width: 180px;
  }
`;

export const TableWrap = styled.div`
  border: 1px solid #E7E8EC;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;

  table {
    width: 100%;
    border-collapse: collapse;

    th {
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: #6B7280;
      text-align: left;
      padding: 12px 14px;
      border-bottom: 1px solid #E7E8EC;
      background: #FAFAFB;
      font-weight: 700;
    }

    td {
      padding: 12px 14px;
      border-bottom: 1px solid #E7E8EC;
      font-size: 13px;
      vertical-align: middle;
      color: #1E2130;
    }

    tr:hover td {
      background: #FCFCFD;
    }

    tr:last-child td {
      border-bottom: none;
    }
  }

  .member-link {
    font-weight: 700;
    cursor: pointer;
    color: #1E2130;

    &:hover {
      color: #CE4A1E;
      text-decoration: underline;
    }
  }

  .rowmuted {
    color: #9297A3;
  }
`;

export const Pill = styled.span`
  display: inline-block;
  font-size: 10.5px;
  font-weight: 800;
  padding: 3px 9px;
  border-radius: 999px;
  letter-spacing: .03em;
  background: ${props => {
    switch (props.variant) {
      case 'pending': return '#FCF1DA';
      case 'approved': case 'paid': return '#E8F8EF';
      case 'rejected': return '#FBEAE8';
      case 'advance': return '#EAF1FE';
      case 'settled': return '#F1EAFB';
      default: return '#EEF0F3';
    }
  }};
  color: ${props => {
    switch (props.variant) {
      case 'pending': return '#B9791A';
      case 'approved': case 'paid': return '#1E9E5A';
      case 'rejected': return '#D5372A';
      case 'advance': return '#2F6FED';
      case 'settled': return '#8B5CE0';
      default: return '#4B4F5C';
    }
  }};
`;

export const Chip = styled.span`
  background: ${props => props.blue ? '#EAF1FE' : '#EEF0F3'};
  color: ${props => props.blue ? '#2F6FED' : '#4B4F5C'};
  font-size: 10.5px;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 6px;
  margin-right: 5px;
`;

export const ActionIconBtn = styled.button`
  border: 1px solid ${props => props.variant === 'approve' ? '#bfe8d1' : '#f2c6c1'};
  background: #fff;
  border-radius: 7px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 13px;
  color: ${props => props.variant === 'approve' ? '#1E9E5A' : '#D5372A'};
  transition: all 0.15s ease;

  &:hover {
    background: ${props => props.variant === 'approve' ? '#E8F8EF' : '#FBEAE8'};
  }
`;

export const Btn = styled.button`
  border: ${props => props.ghost ? '1px solid #E7E8EC' : 'none'};
  border-radius: 10px;
  padding: ${props => props.sm ? '6px 12px' : '10px 18px'};
  font-weight: 700;
  font-size: ${props => props.sm ? '12px' : '13.5px'};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${props => props.ghost ? '#fff' : '#EA5B2A'};
  color: ${props => props.ghost ? '#1E2130' : '#fff'};
  transition: all 0.2s ease;

  &:hover {
    background: ${props => props.ghost ? '#f7f7f9' : '#CE4A1E'};
  }

  &:disabled {
    opacity: .4;
    cursor: not-allowed;
  }
`;

export const DrawerOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(20, 20, 26, .45);
  display: ${props => props.show ? 'block' : 'none'};
  z-index: 1040;
`;

export const DrawerContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 460px;
  max-width: 92vw;
  background: #fff;
  box-shadow: -10px 0 30px rgba(0, 0, 0, .15);
  transform: ${props => props.show ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform .25s ease;
  z-index: 1050;
  display: flex;
  flex-direction: column;

  .drawer-head {
    padding: 22px 24px;
    border-bottom: 1px solid #E7E8EC;

    .close {
      float: right;
      cursor: pointer;
      color: #6B7280;
      font-size: 20px;
      background: none;
      border: none;
    }

    .drawer-name {
      font-size: 20px;
      font-weight: 800;
    }

    .drawer-role {
      font-size: 12.5px;
      color: #6B7280;
      margin-top: 2px;
    }
  }

  .drawer-balance {
    margin-top: 16px;
    background: #181A20;
    color: #fff;
    border-radius: 12px;
    padding: 16px 18px;

    .lbl {
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: .05em;
      color: #b7b9c4;
      font-weight: 700;
    }

    .val {
      font-size: 24px;
      font-weight: 800;
      margin-top: 4px;
    }

    .flag {
      margin-top: 6px;
      font-size: 11.5px;
      color: #ffcdb0;
      font-weight: 700;
    }
  }

  .drawer-actions {
    display: flex;
    gap: 8px;
    margin-top: 14px;
  }

  .drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 8px 24px 24px;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(20, 20, 26, .5);
  display: ${props => props.show ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1060;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 16px;
  width: 480px;
  max-width: 92vw;
  max-height: 88vh;
  overflow-y: auto;
  padding: 24px 26px;

  h2 {
    margin: 0 0 16px;
    font-size: 18px;
    font-weight: 800;
  }
`;
